import axios from "axios";
import { useEffect, useState } from "react";
import { Article } from "../common.interface";
import { toast } from "react-toastify";



export default function useArticle(){
    const [loading,setLoading]=useState<boolean>(false);
    const [articlesData,setArticlesData] = useState<Article[]>([]);

    useEffect(()=>{
        fetchArticles();
    },[]);

    const fetchArticles = async() => {
        try {
            setLoading(true);
              const res = await axios.get(`${process.env.REACT_APP_BASE_URL}/article/`);
              //console.log('==Fetched data:===', res.data.data);

              if(res.status===200){
                const data = res.data.data;
                setArticlesData(data)
              }
      
        } catch (error) {
            toast.error(`${(error as any).message}`, {
                position: toast.POSITION.TOP_LEFT,
                toastId: 'article-fetch-error'

              });   
        } finally{
            setLoading(false);
        }
    }

    const updateArticle = (_data: Article) => {
        setLoading(true);
        // console.log('==Updating Article:===', _data);
        let newData =[...articlesData]
        const updatedData = newData.map((article) =>(article._id === _data._id ? {...article,..._data} : article)
        );
        // console.log('==Updated Articles:===', updatedData);
        setArticlesData((prev)=>(updatedData));
        setLoading(false);
    };

    const createArticle =(data:Article)=>{
        setArticlesData((prev)=>([{...data},...prev]))

    }


    return {
        loading,
        fetchArticles,
        updateArticle,
        articlesData,
        createArticle,
        setArticlesData
    }
}